export const targetList = {
  town: [
    {
      id: '10007010',
      title: '彰化市',
    },
    {
      id: '10007020',
      title: '鹿港鎮',
    },
    {
      id: '10007030',
      title: '和美鎮',
    },
    {
      id: '10007040',
      title: '線西鄉',
    },
    {
      id: '10007050',
      title: '伸港鄉',
    },
    {
      id: '10007060',
      title: '福興鄉',
    },
    {
      id: '10007070',
      title: '秀水鄉',
    },
    {
      id: '10007080',
      title: '花壇鄉',
    },
    {
      id: '10007090',
      title: '芬園鄉',
    },
    {
      id: '10007100',
      title: '員林市',
    },
    {
      id: '10007110',
      title: '溪湖鎮',
    },
    {
      id: '10007120',
      title: '田中鎮',
    },
    {
      id: '10007130',
      title: '大村鄉',
    },
    {
      id: '10007140',
      title: '埔鹽鄉',
    },
    {
      id: '10007150',
      title: '埔心鄉',
    },
    {
      id: '10007160',
      title: '永靖鄉',
    },
    {
      id: '10007170',
      title: '社頭鄉',
    },
    {
      id: '10007180',
      title: '二水鄉',
    },
    {
      id: '10007190',
      title: '北斗鎮',
    },
    {
      id: '10007200',
      title: '二林鎮',
    },
    {
      id: '10007210',
      title: '田尾鄉',
    },
    {
      id: '10007220',
      title: '埤頭鄉',
    },
    {
      id: '10007230',
      title: '芳苑鄉',
    },
    {
      id: '10007240',
      title: '大城鄉',
    },
    {
      id: '10007250',
      title: '竹塘鄉',
    },
    {
      id: '10007260',
      title: '溪州鄉',
    },
  ],
  village: [
    {
      id: 0,
      title: '全芳苑鄉',
    },
    {
      id: '10007230-001',
      title: '芳苑村',
      content: `歷來都將「芳苑村、芳中村、仁愛村、信義村」4個村合稱為芳苑，芳苑古稱番挖或番仔挖，因有港灣，曾經繁榮一時。芳苑目前是芳苑鄉的政治中心，鄉公所設在芳苑村，為全鄉政治、教育、經濟中心。(資料來源：芳苑鄉志)`,
    },
    {
      id: '10007230-002',
      title: '芳中村',
      content: `歷來都將「芳苑村、芳中村、仁愛村、信義村」4個村合稱為芳苑，芳苑古稱番挖或番仔挖，因有港灣，曾經繁榮一時。芳苑目前是芳苑鄉的政治中心，為全鄉政治、教育、經濟中心。(資料來源：芳苑鄉志)`,
    },
    {
      id: '10007230-003',
      title: '仁愛村',
      content: `歷來都將「芳苑村、芳中村、仁愛村、信義村」4個村合稱為芳苑，芳苑古稱番挖或番仔挖，因有港灣，曾經繁榮一時。芳苑目前是芳苑鄉的政治中心，為全鄉政治、教育、經濟中心。(資料來源：芳苑鄉志)`,
    },
    {
      id: '10007230-004',
      title: '信義村',
      content: `歷來都將「芳苑村、芳中村、仁愛村、信義村」4個村合稱為芳苑，芳苑古稱番挖或番仔挖，因有港灣，曾經繁榮一時。芳苑目前是芳苑鄉的政治中心，為全鄉政治、教育、經濟中心。(資料來源：芳苑鄉志)`,
    },
    {
      id: '10007230-005',
      title: '後寮村',
      content: `後寮村村名來源有一說法為前人於三林街後方搭寮拓墾，創建村莊，故稱為後寮壁。後寮村繁華長久不衰，日治時期有「模範部落」之稱，其街道整齊畫一，交通順暢。且馬路筆直，排水設施完善。(資料來源：芳苑鄉志)`,
    },
    {
      id: '10007230-006',
      title: '三合村',
      content: `戰後行政區之劃分由「埤北、過埤、溝仔墘」等三個村落結合而成，所以取名為三合村。從舊地名名稱來看，村落名稱的起源似乎與「埤」、「溝」有關。三合村的過埤行政區劃分為工業區一部分，而成為今日的綜合性的芳苑工業區。(資料來源：芳苑鄉誌、農村再生歷程整合平台)`,
    },
    {
      id: '10007230-007',
      title: '永興村',
      content: `永興村舊地名為外溝仔墘。名起源據當地居民表示，因聚落位於溝旁，故名溝子墘，但在《臺灣舊地名之沿革》中提及，因其聚落往昔位於二林溪北岸，故得名。舊時因二林溪出海口北邊與其流經芳苑鄉之彎折處西邊村落皆命名為溝仔墘，故地方民眾稱呼東邊的溝仔墘為內溝仔墘，靠近海邊的溝仔墘稱為外溝仔墘。(資料來源：芳苑鄉志、農村再生歷程整合平台)`,
    },
    {
      id: '10007230-008',
      title: '五俊村',
      content: `是由「五圳頭、頂埤腳、下埤腳」3個村落組合而成，其中五圳頭的面積較大，也是最早聚集的聚落。日治時期因三個村的保正(村長)大多是埤腳人，所以村庄名以埤腳為主，戰後因村長大多是五圳頭人，故村庄名改為五俊村。(資料來源：芳苑鄉志)`,
    },
    {
      id: '10007230-009',
      title: '路上村',
      content: `歷來都將「路上村、路平村、福榮村、三成村」4個村合稱為路上厝。依《臺灣舊地名之沿革第二冊》記載：「路上厝地名由來，於往昔濱海地域番仔挖，經新厝抵二林，道路上之村落而得名。」而路上厝之「上」字有北邊之意。目前路平村、謝姓祖師廟皆位於姑寮路北邊，因此路上厝之地名起源可能與此路關係較為密切。(資料來源：芳苑鄉志)`,
    },
    {
      id: '10007230-010',
      title: '路平村',
      content: `歷來都將「路上村、路平村、福榮村、三成村」4個村合稱為路上厝。依《臺灣舊地名之沿革第二冊》記載：「路上厝地名由來，於往昔濱海地域番仔挖，經新厝抵二林，道路上之村落而得名。」而路上厝之「上」字有北邊之意。目前路平村、謝姓祖師廟皆位於姑寮路北邊，因此路上厝之地名起源可能與此路關係較為密切。路平村被認定是此4村中最早形成的村落。(資料來源：芳苑鄉志)`,
    },
    {
      id: '10007230-011',
      title: '三成村',
      content: `歷來都將「路上村、路平村、福榮村、三成村」4個村合稱為路上厝。依《臺灣舊地名之沿革第二冊》記載：「路上厝地名由來，於往昔濱海地域番仔挖，經新厝抵二林，道路上之村落而得名。」而路上厝之「上」字有北邊之意。目前路平村、謝姓祖師廟皆位於姑寮路北邊，因此路上厝之地名起源可能與此路關係較為密切。(資料來源：芳苑鄉志)`,
    },
    {
      id: '10007230-012',
      title: '福榮村',
      content: `歷來都將「路上村、路平村、福榮村、三成村」4個村合稱為路上厝。依《臺灣舊地名之沿革第二冊》記載：「路上厝地名由來，於往昔濱海地域番仔挖，經新厝抵二林，道路上之村落而得名。」而路上厝之「上」字有北邊之意。目前路平村、謝姓祖師廟皆位於姑寮路北邊，因此路上厝之地名起源可能與此路關係較為密切。 (資料來源：芳苑鄉志)`,
    },
    {
      id: '10007230-013',
      title: '頂廍村',
      content: `頂廍的地名是由舊式糖廍而來，且當地曾出土舊式糖廍製糖器具，故此說法相對具可信度。而為「頂」之緣由，是因為其位於路上厝的北邊。(資料來源：芳苑鄉志)`,
    },
    {
      id: '10007230-014',
      title: '新街村',
      content: `由「新街、新厝仔、過湖」3個村落組合而成。戰後新街成為新街村，而新厝仔雖沒有成為行政區，不過地方民眾仍稱呼這個小村落為新厝仔庄。另外過湖於舊時曾有一湖，然於路上厝南區農地重劃時被填平。(資料來源：芳苑鄉志)`,
    },
    {
      id: '10007230-015',
      title: '王功村',
      content: `戰後因沙山鄉改為芳苑鄉，王功才細分為「王功村、博愛村、和平村、興仁村、民生村」等5村，故歷來將這5村合稱為王功區。王功舊時又稱王宮，後因認為該地名冒犯皇宮，才改名為王功。目前王功村第十一鄰有「員林寮」之稱，其命名為當初因有幾戶人家從員林遷居至該地，因而得名。(資料來源：芳苑鄉志)`,
    },
    {
      id: '10007230-016',
      title: '博愛村',
      content: `戰後因沙山鄉改為芳苑鄉，王功才細分「王功村、博愛村、和平村、興仁村、民生村」等5村，故歷來將這5村合稱為王功區。王功舊時又稱王宮，後因認為該地名冒犯皇宮，才改名為王功。(資料來源：芳苑鄉志)`,
    },
    {
      id: '10007230-017',
      title: '和平村',
      content: `戰後因沙山鄉改為芳苑鄉，王功才細分為「王功村、博愛村、和平村、興仁村、民生村」等5村，故歷來將這5村合稱為王功區。王功舊時又稱王宮，後因認為該地名冒犯皇宮，才改名為王功。 (資料來源：芳苑鄉志)`,
    },
    {
      id: '10007230-018',
      title: '民生村',
      content: `戰後因沙山鄉改為芳苑鄉，王功才細分為「王功村、博愛村、和平村、興仁村、民生村」等5村，故歷來將這5村合稱為王功區。王功舊時又稱王宮，後因認為該地名冒犯皇宮，才改名為王功。(資料來源：芳苑鄉志)`,
    },
    {
      id: '10007230-019',
      title: '興仁村',
      content: `戰後因沙山鄉改為芳苑鄉，王功才細分為「王功村、博愛村、和平村、興仁村、民生村」等5村，故歷來將這5村合稱為王功區。王功舊時又稱王宮，後因認為該地名冒犯皇宮，才改名為王功。興仁村第六鄰有「入贅庄」之稱，據說過去該聚落的男主人大多為入贅，因而得名。另外興仁村第八、九鄰稱為「下庄仔」，為王功區最早開發的聚落，由於其位於興仁村與永興村之交界處，故永興村的人則稱該地為「頂庄仔」(資料來源：芳苑鄉志)`,
    },
    {
      id: '10007230-020',
      title: '新寶村',
      content: `新寶村有「牛埔頭、牛肚溝、土龍溝、新村」4個村落。地方傳言，台灣光復後漢寶園改為漢寶村，但因面積過大，故以牛肚溝為界線，南邊的牛肚溝、牛埔頭成為了一個新的村，且為紀念漢寶園庄，所以取名為新寶村。「牛埔頭」因其為地勢較高的放牛草原地而得名。「牛肚溝」因當時放養牛隻於舊濁水溪之舊河道喝水，其水流常淹至牛肚而得名。「土龍溝」則因當地以前常可捕捉到土龍而得名。另「新村」則為民國47年新建曾文水庫時，嘉義縣大埔鄉有部分居民遷移至新寶海邊居住，後因水災關係政府提供新寶村東邊公有地使其蓋房居住而得名。(資料來源：芳苑鄉志)`,
    },
    {
      id: '10007230-021',
      title: '草湖村',
      content: `歷來都將「草湖村、文津村、建平村、崙腳村、新生村」5個村合稱為草湖區。草湖古代地理位置是舊濁水溪河床，經常年纍月強勁東北季風吹襲，因此形成一處四面環繞沙丘的低漥地，並且長滿雜草的河床，因而得名草湖。草湖村由「草湖庄、洪龍江寮、崙腳寮、頂厝」等4個村落組成。(資料來源：芳苑鄉志)`,
    },
    {
      id: '10007230-022',
      title: '文津村',
      content: `歷來都將「草湖村、文津村、建平村、崙腳村、新生村」5個村合稱為草湖區。日治時期創建秋津村，至民國35年秋津村改為國光村。後因集體械鬥，於民國41年以功湖路為界線，北邊劃分為新生村，南邊劃分為文津村。(資料來源：芳苑鄉志)`,
    },
    {
      id: '10007230-023',
      title: '建平村',
      content: `歷來都將「草湖村、文津村、建平村、崙腳村、新生村」5個村合稱為草湖區。建平村原屬草湖庄之轄區，直至戰後從草湖庄分割一部份，取名為建平村。地方傳言陳建上一家為地方望族，於建平村內有一部份土地，故推測其名稱由來與陳建上家族有關。(資料來源：芳苑鄉志)`,
    },
    {
      id: '10007230-024',
      title: '崙腳村',
      content: `歷來都將「草湖村、文津村、建平村、崙腳村、新生村」5個村合稱為草湖區。地方傳言因居民在大沙崙南麓建屋聚集成村落，故被稱為崙腳庄，也稱作崙仔腳或大崙腳。崙腳村的沙崙，目前還在，約有2成樓高，其位置位於王功東北方2.4公里處。(資料來源：芳苑鄉志、農村再生歷程整合平台)`,
    },
    {
      id: '10007230-025',
      title: '新生村',
      content: `歷來都將「草湖村、文津村、建平村、崙腳村、新生村」5個村合稱為草湖區。日治時期創建秋津村，至民國35年秋津村改為國光村。後因集體械鬥，於民國41年以功湖路為界線，北邊劃分為新生村，南邊劃分為文津村。(資料來源：芳苑鄉志)`,
    },
    {
      id: '10007230-026',
      title: '漢寶村',
      content: `日治時期漢寶村又名八洲村，目前村內留有一條八洲排水。另漢寶村海尾的天寶宮建廟時碑記載：「六十年前之漢寶，原名溪底，又名漢寶園。」漢寶村有約6公里長的海岸線以及約2000公頃的潮間帶。在堤岸內有約400公頃的專業養殖區。(資料來源：芳苑鄉志、農村再生歷程整合平台)`,
    },
  ],
};

export const populationThemeList = [
  {
    id: '戶數',
    unit: '戶',
  },
  {
    id: '人口數',
    unit: '人',
  },
  {
    id: '人口密度',
    unit: '人/k㎡',
  },
  {
    id: '性別比',
    unit: '%',
  },
  {
    id: '扶養比',
    unit: '%',
  },
  {
    id: '扶幼比',
    unit: '%',
  },
  {
    id: '扶老比',
    unit: '%',
  },
  {
    id: '老化指數',
    unit: '%',
  },
  {
    id: '粗出生率',
    unit: '‰',
  },
  {
    id: '粗死亡率',
    unit: '‰',
  },
  {
    id: '自然增加率',
    unit: '‰',
  },
  {
    id: '社會增加率',
    unit: '‰',
  },
  {
    id: '人口增加率',
    unit: '‰',
  },
  {
    id: '幼年人口數',
    unit: '人',
  },
  {
    id: '青壯年人口數',
    unit: '人',
  },
  {
    id: '老年人口數',
    unit: '人',
  },
];

export const populationThemeTermList = [
  {
    oldKey: '人口數小計',
    newKey: '人口數',
  },
  {
    oldKey: '人口密度( 人／平方公里 )',
    newKey: '人口密度',
  },
  {
    oldKey: '性別比(男／女)x 100',
    newKey: '性別比',
  },
  {
    oldKey: '0~14歲',
    newKey: '幼年人口數',
  },
  {
    oldKey: '0-14歲人口數',
    newKey: '幼年人口數',
  },
  {
    oldKey: '15~64歲',
    newKey: '青壯年人口數',
  },
  {
    oldKey: '15-64歲人口數',
    newKey: '青壯年人口數',
  },
  {
    oldKey: '65歲以上',
    newKey: '老年人口數',
  },
  {
    oldKey: '65歲以上人口數',
    newKey: '老年人口數',
  },
  {
    oldKey: '戶數(戶)',
    newKey: '戶數',
  },
  {
    oldKey: '人口數(人)',
    newKey: '人口數',
  },
  {
    oldKey: '人口密度(人/k㎡)',
    newKey: '人口密度',
  },
  {
    oldKey: '扶養比(%)',
    newKey: '扶養比',
  },
  {
    oldKey: '扶幼比(%)',
    newKey: '扶幼比',
  },
  {
    oldKey: '扶老比(%)',
    newKey: '扶老比',
  },
  {
    oldKey: '老化指數(%)',
    newKey: '老化指數',
  },
  {
    oldKey: '粗出生率(‰)',
    newKey: '粗出生率',
  },
  {
    oldKey: '粗死亡率(‰)',
    newKey: '粗死亡率',
  },
  {
    oldKey: '粗死亡率(‰)',
    newKey: '粗死亡率',
  },
  {
    oldKey: '自然增加率(‰)',
    newKey: '自然增加率',
  },
  {
    oldKey: '社會增加率(‰)',
    newKey: '社會增加率',
  },
  {
    oldKey: '人口增加率(‰)',
    newKey: '人口增加率',
  },
  {
    oldKey: '0-14歲人口數(人)',
    newKey: '幼年人口數',
  },
  {
    oldKey: '15-64歲人口數(人)',
    newKey: '青壯年人口數',
  },
  {
    oldKey: '65歲以上人口數(人)',
    newKey: '老年人口數',
  },
];

export const economyAndIndustryThemeList = [
  {
    id: '行政區工商家數',
    unit: '家',
  },
  {
    id: '耕作地面積',
    unit: '公頃',
  },
  {
    id: '作物面積總計',
    unit: '公頃',
  },
  {
    id: '作物產量總計(稻米、蔬菜、果品、特用、雜糧)',
    unit: '公噸',
  },
  {
    id: '漁戶人口數(遠洋、近海、沿海、海面養殖、內陸漁撈、內陸養殖)',
    unit: '人',
  },
  {
    id: '家畜數(牛、馬、豬、鹿、兔、羊)',
    unit: '頭',
  },
  {
    id: '家禽數(蛋雞、肉雞、蛋鴨、肉鴨、鵝、火雞)',
    unit: '千隻',
  },
];

export const economyAndIndustryThemeTermList = [
  {
    oldKey: '工商業總家數',
    newKey: '行政區工商家數',
  },
  {
    oldKey: '農產產量總計',
    newKey: '作物產量總計(稻米、蔬菜、果品、特用、雜糧)',
  },
  {
    oldKey: '農產產量總計(公噸)',
    newKey: '作物產量總計(稻米、蔬菜、果品、特用、雜糧)',
  },
  {
    oldKey: '農產收穫面積總計',
    newKey: '作物面積總計',
  },
  {
    oldKey: '農產收穫面積總計(公頃)',
    newKey: '作物面積總計',
  },
  {
    oldKey: '家禽數(蛋雞、肉雞、蛋鴨、肉鴨、鵝、火雞)-千隻',
    newKey: '家禽數(蛋雞、肉雞、蛋鴨、肉鴨、鵝、火雞)',
  },
  {
    oldKey: '畜數(牛、馬、豬、鹿、兔、羊)-頭',
    newKey: '家畜數(牛、馬、豬、鹿、兔、羊)',
  },
  {
    oldKey: '家畜數(牛、馬、豬、鹿、兔、羊)-頭',
    newKey: '家畜數(牛、馬、豬、鹿、兔、羊)',
  },
  {
    oldKey: '漁業人口數',
    newKey: '漁戶人口數(遠洋、近海、沿海、海面養殖、內陸漁撈、內陸養殖)',
  },
  {
    oldKey: '農耕土地總計(公頃)',
    newKey: '耕作地面積',
  },
  {
    oldKey: '農耕土地總計',
    newKey: '耕作地面積',
  },
];

export const agriculturePlantedAreaTermList = [
  {
    oldKey: '耕作地/合計',
    newKey: '耕作地',
  },
];

export const agricultureYieldAreaTermList = [
  {
    oldKey: '稻米合計_收穫面積',
    newKey: '稻米',
  },
  {
    oldKey: '果品總計_收穫面積',
    newKey: '果品',
  },
  {
    oldKey: '雜糧總計_收穫面積',
    newKey: '雜糧作物',
  },
  {
    oldKey: '特用作物總計_收穫面積',
    newKey: '特用作物',
  },
];

export const agricultureYieldAmountTermList = [
  {
    oldKey: '稻米合計_產量',
    newKey: '稻米',
  },
  {
    oldKey: '果品總計_產量',
    newKey: '果品',
  },
  {
    oldKey: '雜糧總計_產量',
    newKey: '雜糧作物',
  },
  {
    oldKey: '特用作物總計_產量',
    newKey: '特用作物',
  },
];

export const fisheryTermList = [
  {
    oldKey: '人口數_遠洋漁業',
    newKey: '遠洋漁業',
  },
  {
    oldKey: '人口數_近海漁業',
    newKey: '近海漁業',
  },
  {
    oldKey: '人口數_沿海漁業',
    newKey: '沿海漁業',
  },
  {
    oldKey: '人口數_海面養殖業',
    newKey: '海面養殖業',
  },
  {
    oldKey: '人口數_內陸魚撈業',
    newKey: '內陸魚撈業',
  },
  {
    oldKey: '人口數_內陸養殖業',
    newKey: '內陸養殖業',
  },
];

export const animalHusbandaryLivestockTermList = [];

export const villageOysterHorizontalHangingTermList = [
  {
    oldKey: '牡蠣',
    newKey: '年份',
  },
  {
    oldKey: '芳苑鄉',
    newKey: '設施(組)',
  },
  {
    oldKey: '',
    newKey: '養殖（戶）',
  },
];

export const villageOysterTermList = [
  {
    oldKey: '全國',
    newKey: '年份',
  },
  {
    oldKey: '彰化縣',
    newKey: '年份',
  },
  {
    oldKey: '芳苑鄉',
    newKey: '年份',
  },
];

export const villageOysterFacilityTermList = [
  {
    oldKey: '平掛式設施(組)',
    newKey: '平掛式',
  },
  {
    oldKey: '插篊式設施(組)',
    newKey: '插篊式',
  },
  {
    oldKey: '垂下式設施(棚)',
    newKey: '垂下式',
  },
  {
    oldKey: '浮筏式設施(棚)',
    newKey: '浮筏式',
  },
  {
    oldKey: '延繩式設施(組)',
    newKey: '延繩式',
  },
];

export const villageOysterFarmingTermList = [
  {
    oldKey: '平掛式養殖（戶）',
    newKey: '平掛式',
  },
  {
    oldKey: '插篊式養殖（戶）',
    newKey: '插篊式',
  },
  {
    oldKey: '垂下式養殖（戶）',
    newKey: '垂下式',
  },
  {
    oldKey: '浮筏式養殖（戶）',
    newKey: '浮筏式',
  },
  {
    oldKey: '延繩式養殖（戶）',
    newKey: '延繩式',
  },
];

export const villageFishesTermList = [
  {
    oldKey: '文蛤',
    newKey: '年份',
  },
  {
    oldKey: '烏魚',
    newKey: '年份',
  },
  {
    oldKey: '虱目魚',
    newKey: '年份',
  },
  {
    oldKey: '蜆',
    newKey: '年份',
  },
  {
    oldKey: '白蝦',
    newKey: '年份',
  },
  {
    oldKey: '吳郭魚',
    newKey: '年份',
  },
  {
    oldKey: '鰻魚',
    newKey: '年份',
  },
  {
    oldKey: '日本黑蜆',
    newKey: '年份',
  },
  {
    oldKey: '西施貝',
    newKey: '年份',
  },
  {
    oldKey: '養殖面積（公頃）',
    newKey: '養殖面積',
  },
  {
    oldKey: '在池-放養量（尾、粒、隻）',
    newKey: '在池',
  },
  {
    oldKey: '新放養-放養量（尾、粒、隻）',
    newKey: '新放養',
  },
];
